import React, { useState } from 'react';
import { Avatar, Box, Button, Card, Divider, Grid, Modal, Stack, Typography } from '@mui/material';
import PageHeading from '../../../Components/PageHeading';
import { CloseIcon } from '../../../Components/Icons/Icons';
import img1 from '../../../Assets/Image/img1.svg';
import img2 from '../../../Assets/Image/img2.svg';
import { AppColors } from '../../../Utils/helper/AppColors';
import { useNavigate } from 'react-router-dom';
import { PATH_NAME } from '../../../Routes/Pathname';
import { Select, MenuItem } from '@mui/material';
import SelectCampaign from '../../../Components/SelectCampaign';
import toast from 'react-hot-toast';
import { HelperTexts } from '../../../Utils/helper/HelperTexts';
import CultService from '../../../Services/CultService';
import { useSelector } from 'react-redux';
import { CAMPAIGN_STATUS } from '../../../Utils/helper/AppConstants';
import dayjs from 'dayjs';

export default function CampaignCreateOrDuplicateModal({ open, onClose, fetchCampaigns }) {
	const [isDuplicate, setIsDuplicate] = useState(false);
	const [details, setDetails] = useState({ campaignId: '', userType: '' }); // <-- Add this line
	const [loading, setLoading] = useState(false);
	const [list, setList] = useState([]);
	const companyId = useSelector((state) => state?.app?.company)?._id;

	const createDraftCampaign = async (detailsCampaign, status = CAMPAIGN_STATUS.draft.code) => {
		setLoading(true);
		try {
			const res = await CultService.createCampaign({ data: { ...detailsCampaign, status, companyId } });

			if (res.status == 200) {
				onClose();
				fetchCampaigns();
			}
		} catch (err) {
			toast.error(HelperTexts.SOMETHING_WENT_WRONG);
		} finally {
			setLoading(false);
		}
	};

	const getList = async (page = 1, limit = 1000, type) => {
		setLoading(true);
		let updatedCampaignId = { ...details.campaignId, users: [] };

		try {
			let res = await CultService.getParticipatedNonParticipatedUsersPaginated({
				params: { page, limit  , companyId, campaignId: details?.campaignId?._id, type: type , filterQuery: {} },
			});

			if (res.status == 200) {
				// console.log('res--2', res);
				const selectedUsers = res?.data?.users?.filter((user) => user?.selected).map((user) => user._id) || [];
				// console.log('selectedUsers -', selectedUsers);
				updatedCampaignId.users = selectedUsers;
				// console.log('updatedCampaignId - ', updatedCampaignId);
			}
		} catch (err) {
			// alert('Error fetching campaign users:', err);
			toast.error(HelperTexts.SOMETHING_WENT_WRONG);
		} finally {
			setLoading(false);
		}

		return updatedCampaignId;
	};

	const navigate = useNavigate();

	const handleSelectCampaign = (i, option) => {
		// console.log('Selected Campaignid:', i);// console.log('Selected Option:', option);
		setDetails({ ...details, campaignId: option.item });
	};
	const handleInputChange = (key, value) => {
		// console.log('Selected Value:', value);
		setDetails({ ...details, [key]: value });
	};

	function sanitizeSchedulingDates(scheduling) {
		if (!scheduling) return scheduling;
		const today = dayjs().startOf('day');
		const startDate = scheduling.startDate ? dayjs(scheduling.startDate, 'YYYY-MM-DD') : null;
		const endDate = scheduling.endDate ? dayjs(scheduling.endDate, 'YYYY-MM-DD') : null;

		if ((startDate && startDate.isBefore(today, 'day')) || (endDate && endDate.isBefore(today, 'day'))) {
			return { ...scheduling, startDate: null, endDate: null };
		}
		return scheduling;
	}

	const handleDraftCampaign = async () => {
		switch (details.userType) {
			case 'same': {
				let users = details?.campaignId?.compaignUser?.map((i) => i?.userId?._id);
				let scheduling = sanitizeSchedulingDates(details?.campaignId?.scheduling);

				let campaign = { ...details.campaignId, users: users, scheduling };
				// console.log('camp', campaign);
				// console.log('users', users);
				await createDraftCampaign(campaign);
				break;
			}

			case 'participated': {
				let updatedCampaign = await getList(1, 1000, '1');
				let scheduling = sanitizeSchedulingDates(updatedCampaign?.scheduling);
				let campaign = { ...updatedCampaign, scheduling };

				await createDraftCampaign(campaign);

				break;
			}

			case 'non-participated': {
				let updatedCampaign = await getList(1, 1000, '2');
				let scheduling = sanitizeSchedulingDates(updatedCampaign?.scheduling);
				let campaign = { ...updatedCampaign, scheduling };

				await createDraftCampaign(campaign);

				break;
			}
			case 'new':
				let users = [];
				let scheduling = sanitizeSchedulingDates(details?.campaignId?.scheduling);

				let campaign = { ...details.campaignId, users: users, scheduling };
				// console.log('camp', campaign);
				// console.log('users', users);
				await createDraftCampaign(campaign);
				break;
			default:
				break;
		}
	};

	const handleCreateCampaign = async () => {
		switch (details.userType) {
			case 'same':
				navigate(PATH_NAME.CAMPAIGN_COPY, { state: { campaign: { ...details.campaignId, copy: true, type: '0' } } });
				break;

			case 'participated': {
				const updatedCampaign = await getList(1, 1000, '1');
				// console.log('updatedCampaign', updatedCampaign);

				navigate(PATH_NAME.CAMPAIGN_COPY, { state: { campaign: { ...updatedCampaign, copy: true, type: '1' } } });
				break;
			}

			case 'non-participated':
				{
					const updatedCampaign = await getList(1, 1000, '2');
					// console.log('updatedCampaign', updatedCampaign);
					navigate(PATH_NAME.CAMPAIGN_COPY, { state: { campaign: { ...updatedCampaign, copy: true, type: '2' } } });
					break;
				}
				await getList(1, 100, '2');
				// toast.error('working on it');
				// navigate(PATH_NAME.CAMPAIGN_COPY, { state: { campaign: { ...details.campaignId, copy: true, type: '2' } } });

				break;
			case 'new':
				// toast.error('working on it');
				navigate(PATH_NAME.CAMPAIGN_CREATE, {
					state: { campaign: { ...details.campaignId, copy: true, compaignUser: [], type: '3' } },
				});
				break;
			default:
				break;
		}
	};

	// console.log('Details:', details);
	return (
		<Modal open={open}>
			<Box
				sx={{
					position: 'absolute',
					top: '50%',
					left: '50%',
					transform: 'translate(-50%, -50%)',
					bgcolor: '#fff',
					border: '1px solid #DEE2E4',
					boxShadow: 24,
					borderRadius: '12px',
					width: { xs: '100%', sm: '100%', md: '732px' },
					height: '583px',
					zIndex: 100,
				}}
			>
				<Stack sx={{ px: '20px', py: '10px' }}>
					<PageHeading
						title={isDuplicate ? 'Create Duplicate Campaign' : 'Create Campaign'}
						subTitle={
							isDuplicate
								? 'Easily replicate settings for previous campaign'
								: 'Create a new campaign from scratch or duplicate an existing one to get started quickly.'
						}
						renderRight={
							<CloseIcon
								onClick={() => {
									setIsDuplicate(false);
									onClose();
								}}
								color="#98A2B3"
								size={24}
							/>
						}
					/>
				</Stack>
				<Divider sx={{ mb: 3 }} />

				{!isDuplicate ? (
					<Stack direction={{ xs: 'column', sm: 'row' }} sx={{ px: '60px', py: '20px' }} spacing={3}>
						{/* Left Card (Start Fresh) */}
						<Card
							sx={(theme) => ({
								flex: 1,
								py: '50px',
								px: '30px',
								display: 'flex',
								gap: '10px',
								flexDirection: 'column',
								alignItems: 'center',
								boxShadow: 2,
								border: `1px solid ${theme.palette.primary.light_shade}`,
								borderRadius: '10px',
								backgroundColor: AppColors.WHITE, // Default: white like second card
								transition: 'background 0.2s, border 0.2s',
								cursor: 'pointer',
								'&:hover': {
									backgroundColor: theme.palette.primary.lightest_shade,
									border: `1.5px solid ${theme.palette.primary.darker_primary}`,
								},
								'&:hover .MuiButton-outlined': {
									backgroundColor: theme.palette.primary.primary_shade,
									color: '#fff',
									borderColor: theme.palette.primary.primary_shade,
								},
							})}
						>
							<Box
								sx={theme => ({
									width: 90,
									height: 90,
									mb: 2,
									border: `1px solid ${theme.palette.primary.light_shade}`,
									borderRadius: '50%',
									display: 'flex',
									alignItems: 'center',
									justifyContent: 'center',
									background: theme.palette.primary.lightest_shade, // Default: light shade
									p: 1.5,
									transition: 'background 0.2s',
									// Avatar background changes on card hover
									'.MuiCard-root:hover &': {
										background: AppColors.WHITE,
									},
								})}
							>
								<Avatar
									src={img1}
									alt="New Campaign"
									sx={{
										width: 50,
										height: 50,
										borderRadius: '50%',
										background: 'transparent',
									}}
								/>
							</Box>

							<Typography
								sx={{ fontSize: '14px', fontWeight: 400, lineHeight: '18px', fontFamily: 'Poppins' }}
								mb={2}
								textAlign="center"
							>
								<Typography
									component="span"
									sx={(theme) => ({
										color: theme.palette.primary.darker_primary,
										fontWeight: 600,
									})}
								>
									Start fresh
								</Typography>{' '}
								by setting up a new campaign from scratch.
							</Typography>

							<Button
								variant="outlined"
								color="info"
								sx={{
									borderRadius: '4px',
									px: '30px',
									marginTop: '8px',
									background: '#fff',
									fontWeight: 600,
									transition: 'all 0.2s',
									width: '140px',
								}}
								onClick={() => navigate(PATH_NAME.CAMPAIGN_CREATE)}
							>
								Start
							</Button>
						</Card>

						{/* Right Card (Duplicate) */}
						<Card
							sx={(theme) => ({
								flex: 1,
								py: '50px',
								px: '30px',
								display: 'flex',
								gap: '10px',
								flexDirection: 'column',
								alignItems: 'center',
								boxShadow: 2,
								border: `1px solid ${theme.palette.primary.light_shade}`,
								borderRadius: '10px',
								backgroundColor: AppColors.WHITE,
								transition: 'background 0.2s, border 0.2s',
								cursor: 'pointer',
								'&:hover': {
									backgroundColor: theme.palette.primary.lightest_shade,
									border: `1.5px solid ${theme.palette.primary.darker_primary}`,
								},
								'&:hover .MuiButton-outlined': {
									backgroundColor: theme.palette.primary.primary_shade,
									color: '#fff',
									borderColor: theme.palette.primary.primary_shade,
								},
							})}
						>
							<Box
								sx={theme => ({
									width: 90,
									height: 90,
									mb: 2,
									border: `1px solid ${theme.palette.primary.light_shade}`,
									borderRadius: '50%',
									display: 'flex',
									alignItems: 'center',
									justifyContent: 'center',
									background: theme.palette.primary.lightest_shade,
									p: 1.5,
									transition: 'background 0.2s',
									'.MuiCard-root:hover &': {
										background: AppColors.WHITE,
									},
								})}
							>
								<Avatar
									src={img2}
									alt="Duplicate Campaign"
									sx={{
										width: 50,
										height: 50,
										borderRadius: '50%',
										background: 'transparent',
									}}
								/>
							</Box>

							<Typography
								sx={{ fontSize: '14px', fontWeight: 400, lineHeight: '18px', fontFamily: 'Poppins' }}
								mb={2}
								textAlign="center"
							>
								<Typography
									component="span"
									sx={(theme) => ({
										color: theme.palette.primary.darker_primary,
										fontWeight: 600,
									})}
								>
									Duplicate a campaign
								</Typography>
								to quickly launch.
							</Typography>
							<Button
								variant="outlined"
								color="info"
								sx={{
									borderRadius: '4px',
									px: '30px',
									marginTop: '8px',
									background: '#fff',
									fontWeight: 600,
									transition: 'all 0.2s',
									width: '140px',
								}}
								onClick={() => setIsDuplicate(true)}
							>
								Start
							</Button>
						</Card>
					</Stack>
				) : (
					// DUMMY DUPLICATE CAMPAIGN CONTENT
					<Stack
						sx={{
							px: '60px',
							py: '40px',
							height: 'calc(100% - 120px)',
							boxSizing: 'border-box',
							display: 'flex',
							flexDirection: 'column',
							justifyContent: 'flex-start',
							alignItems: 'center',
							position: 'relative',
						}}
					>
						<Stack direction="column" alignItems="center" gap={4} sx={{ width: '100%' }}>
							<Grid container sx={{ width: '100%' }}>
								<Grid item xs={12} sx={{ mx: 'auto' }}>
									<div style={{ position: 'relative', width: '100%' }}>
										<Typography
											sx={{
												position: 'absolute',
												top: '-10px',
												left: '12px',
												background: '#fff',
												padding: '0 4px',
												fontSize: 12,
												color: AppColors.HEADING_TITLE4,
												fontFamily: 'Poppins',
												fontWeight: 400,
												lineHeight: '115%',
												zIndex: 100000,
											}}
										>
											Campaign
										</Typography>
										<SelectCampaign
											handleSelectCampaign={handleSelectCampaign}
											width={'100%'}
											bgColor={'#ffffff'}
											color={'#000000'}
											noCustomClass={true}
										/>
									</div>
								</Grid>
							</Grid>
							<Grid container sx={{ width: '100%' }}>
								<Grid item xs={12} sx={{ mx: 'auto' }}>
									<div style={{ position: 'relative', width: '100%' }}>
										<Typography
											sx={{
												position: 'absolute',
												top: '-10px',
												left: '12px',
												background: '#fff',
												padding: '0 4px',
												fontSize: 12,
												color: AppColors.HEADING_TITLE4,
												fontFamily: 'Poppins',
												fontWeight: 400,
												lineHeight: '115%',
												zIndex: 1,
											}}
										>
											Select User
										</Typography>
										<Select
											onChange={(e) => handleInputChange('userType', e.target.value)}
											displayEmpty
											fullWidth
											value={details?.userType}
											renderValue={(selected) => {
												const found = [
													{ label: 'Select User Type', value: '' },
													{ label: 'Same User as existing campaign', value: 'same' },
													{ label: 'Participated User', value: 'participated' },
													{ label: 'Non-Participated User', value: 'non-participated' },
													{ label: 'New Users', value: 'new' },
												].find((i) => i.value === selected);
												return found ? found.label : 'Select User Type';
											}}
											sx={{
												background: '#F8F9FC',
												borderRadius: 2,
												'& .MuiSelect-select': {
													padding: '10px 12px',
												},
											}}
										>
											<MenuItem value="">Select User Type</MenuItem>
											<MenuItem value="same">Same User as existing campaign</MenuItem>
											<MenuItem value="participated">Participated User</MenuItem>
											<MenuItem value="non-participated">Non-Participated User</MenuItem>
											<MenuItem value="new">New Users</MenuItem>
										</Select>
									</div>
								</Grid>
							</Grid>
						</Stack>

						<Stack
							pt={2}
							borderTop={`1px solid ${AppColors.BORDER_GREY}`}
							direction="row"
							justifyContent={'center'}
							gap={2}
							sx={{
								position: 'absolute',
								left: 0,
								bottom: 0,
								width: '100%',
								bgcolor: AppColors.WHITE,
								borderRadius: '0 0 12px 12px',
							}}
						>
							<Button
								onClick={() => {
									setIsDuplicate(false);
									onClose();
								}}
								variant="outlined"
								type="default"
								sx={{ width: { sm: '160px', md: '215px' }, borderRadius: '2px' }}
							>
								Cancel
							</Button>
							<Button
								loading={loading}
								disabled={!details?.userType || !details?.campaignId}
								variant="outlined"
								type="default"
								sx={{ width: { sm: '160px', md: '215px' }, borderRadius: '2px' }}
								onClick={() => handleDraftCampaign()}
							>
								Save as Draft
							</Button>
							<Button
								loading={loading}
								disabled={!details?.userType || !details?.campaignId}
								variant="contained"
								type="primary"
								sx={{ width: { sm: '160px', md: '215px' }, borderRadius: '2px' }}
								onClick={() => handleCreateCampaign()}
							>
								Next
							</Button>
						</Stack>
					</Stack>
				)}
			</Box>
		</Modal>
	);
}
